




















import { Component, Vue, Watch } from "vue-property-decorator";

@Component({})
export default class App extends Vue {
  private showScreenSaver = false;
  private videoInterval = 60000;
  private videoUrl = "";
  private timer = -1;
  private webViewerUrl =
    "https://cdn.flipsnack.com/widget/v2/widget.html?hash=7u8r3jprzp";

  constructor() {
    super();
    const params = new URLSearchParams(window.location.search.slice(1));
    if (params.has("videoInterval")) {
      this.videoInterval =
        parseInt(params.get("videoInterval") || "") * 1000 || 60000;
    }
    if (params.has("videoUrl")) {
      this.videoUrl = params.get("videoUrl") || "";
      caches.open("video-cache").then(c =>
        c.add(this.videoUrl).then(() => {
          console.log("cache done", this.videoUrl);
        })
      );
    }
    setInterval(this.checkFocus, 2000);
  }

  mounted() {
    const screenSaver = document.querySelector(
      "#screen-saver"
    ) as HTMLVideoElement;
    if (screenSaver) {
      screenSaver.addEventListener("touchstart", this.hideScreenSaver, false);
      screenSaver.addEventListener("onmousedown", this.hideScreenSaver, false);
    }
  }

  destroyed() {
    const screenSaver = document.querySelector(
      "#screen-saver"
    ) as HTMLVideoElement;
    if (screenSaver) {
      screenSaver.removeEventListener("touchstart", this.hideScreenSaver);
      screenSaver.removeEventListener("onmousedown", this.hideScreenSaver);
    }
  }

  private userInactivity = false;

  private checkFocus() {
    // Pokud je zobrazeny screen saver, tak nekontroluj focus
    if (this.showScreenSaver) {
      return;
    }

    // Je uživatel kliknul do iframe
    if (document.activeElement == document.querySelector("#web-viewer")) {
      this.userInactivity = false;
      const d = document.activeElement as HTMLElement;
      d.blur();
      console.log("user activity detected");
    } else {
      this.userInactivity = true;
      console.log("user activity not detected");
    }
  }

  @Watch("userInactivity")
  onUserInactivityChanged(value: boolean, oldValue: boolean) {
    if (value === false) {
      clearTimeout(this.timer);
    } else {
      this.timer = setTimeout(this.showScreensaver, this.videoInterval);
    }
  }

  private showScreensaver() {
    console.log("showScreensaver");
    const web = document.querySelector("#web-viewer") as HTMLIFrameElement;
    // web.src = web.src.split("?")[0] + "?_=" + new Date().getTime();
    web.src = "about:blank";
    setTimeout(() => {
      web.src = this.webViewerUrl;
    }, 1000);
    const video = document.querySelector("#video") as HTMLVideoElement;
    video.src = this.videoUrl;
    video.currentTime = 0;
    video.play();
    this.showScreenSaver = true;
  }

  private hideScreenSaver() {
    this.showScreenSaver = false;
    const video = document.querySelector("#video") as HTMLVideoElement;
    video.pause();
  }
}
